import React from 'react'
import { Col } from 'antd'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { useStepsContext } from 'src/views/Requests/views/Form'
import StepsNavigation from 'src/views/Requests/views/Form/components/StepsNavigation'

import SearchCard from './components/search-card'
import SearchResultCard from './components/search-result-card'
import SummaryCard from './components/summary-card'

import { WrapRow } from '../../../styles'
import BudgetCard from '../../../Assignment/components/Budget/budget-card'

function Vehicles() {
  const { vehicles } = useSelector((state: ApplicationState) => ({
    vehicles: state.vehicles
  }))

  const stepsContext = useStepsContext()

  return (
    <>
      <StepsNavigation />
      <WrapRow>
        <Col span={15}>
          <SearchCard request={stepsContext.request} />
          {vehicles.hasFinish && (
            <SearchResultCard request={stepsContext.request} />
          )}
        </Col>
        <Col offset={1} span={8}>
          {stepsContext.budgetChartAllocations.active && <BudgetCard />}
          <SummaryCard
            bodyStyle={{ minHeight: 220 }}
            handleDelete={deleteItem => {
              stepsContext.setBudgetAllocations({
                standard_type: 'VEHICLE',
                tickets: []
              })

              stepsContext.setRequest({
                ...stepsContext.request,
                full_request_vehicle: []
              })
            }}
            request={stepsContext.request}
          />
        </Col>
      </WrapRow>
    </>
  )
}

export default Vehicles
